module.exports = __webpack_public_path__ + "img/logo_s.20201ea5.svg";